<script setup lang="ts"></script>

<template>
  <dl class="flex flex-col gap-2">
    <slot></slot>
  </dl>
</template>
